module.exports = __webpack_public_path__ + "img/newspaper-top.14d4f89e.png";